import { Trans } from '@lingui/react/macro';
import { Stack, Typography, ButtonBase } from '@mui/material';
import { useRouter } from 'next/router';
import { routeForOrganizationUsers } from '@watershed/shared-universal/dashboardRoutes';
import ArrowRightIcon from '@watershed/icons/components/ArrowRight';
import Avatar from '@watershed/ui-core/components/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
interface AddTeamBannerProps {
  userIds: Array<string>;
}

export function AddTeamBanner({ userIds }: AddTeamBannerProps) {
  const router = useRouter();

  const handleNavigation = async () => {
    await router.push(routeForOrganizationUsers());
  };

  return (
    <ButtonBase
      onClick={handleNavigation}
      sx={{
        borderRadius: '100px',

        background: (theme) =>
          `linear-gradient(180deg, ${theme.palette.cobalt100} 0%, ${theme.palette.cobalt70} 100%)`,
        color: (theme) => theme.palette.white,
        boxShadow:
          '0px 24px 24px -12px rgba(0, 0, 0, 0.06), 0px 12px 12px -6px rgba(0, 0, 0, 0.06), 0px 6px 6px -3px rgba(0, 0, 0, 0.06), 0px 3px 3px -1.5px rgba(0, 0, 0, 0.06), 0px 1px 1px -0.5px rgba(0, 0, 0, 0.06), 0px 0px 0px 1px rgba(0, 0, 0, 0.06)',
        border: (theme) => `1px solid ${theme.palette.cobalt100}}`,
      }}
    >
      <Stack
        direction="row"
        px={3.5}
        py={1.5}
        width="100%"
        sx={{
          cursor: 'pointer',
        }}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack gap={1.5} direction="row" alignItems="center">
          <AvatarGroup max={3}>
            {userIds.map((userId) => (
              <Avatar key={userId} variant="person" name={userId} />
            ))}
          </AvatarGroup>
          <Typography
            variant="h4"
            sx={{ color: (theme) => theme.palette.white }}
          >
            <Trans>Add your team</Trans>
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography
            variant="body1"
            sx={{ color: (theme) => theme.palette.white }}
          >
            <Trans>Invite users to make the most of Watershed</Trans>
          </Typography>
          <ArrowRightIcon size={16} />
        </Stack>
      </Stack>
    </ButtonBase>
  );
}
